import React, { useState, useEffect } from "react";
import { BsX } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import CustomProfileImage from "../../user/profile/CustomProfileImage";

const ConfigBroadcastLiveMember = ({ selectedLiveInfo, handleSelectedConfigFunc, userSeq }) => {
    const { t } = useTranslation();

    const nullData = [];
    const nullMember = nullData.map(member => ({ userSeq: member.userSeq, nickname: member.userNickname, isSelect: false }));

    const liveMember = selectedLiveInfo.list_member.map(member => ({ userSeq: member.userSeq, nickname: member.userNickname, isSelect: false }));

    const [lMembers, setMembers] = useState(nullMember);

    const [lSearchValue, setSearchValue] = useState("");
    const [list_searchMember, setListSearchMember] = useState([]);
    const [list_searchWaitMember, setListSearchWaitMember] = useState([]);

    useEffect(() => {
        if (selectedLiveInfo) {
            if (selectedLiveInfo.list_waitMember) {
                setListSearchWaitMember(selectedLiveInfo.list_waitMember);
            }

            if (selectedLiveInfo.list_member) {
                setListSearchMember(selectedLiveInfo.list_member);
            }
        }
    }, [selectedLiveInfo]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearchValue(lSearchValue);
        }
    }

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    const onChangeSearchValue = (e) => {
        setSearchValue(e.target.value);
        handleSearchValue(e.target.value);
    }

    const handleSearchValue = (keyword) => {
        let newKeyword = keyword.toLowerCase();

        if (newKeyword === "") {
            if (selectedLiveInfo) {
                if (selectedLiveInfo.list_waitMember) {
                    setListSearchWaitMember(selectedLiveInfo.list_waitMember);
                }

                if (selectedLiveInfo.list_member) {
                    setListSearchMember(selectedLiveInfo.list_member);
                }
            }
            return;
        }

        try {

            let wait_result = selectedLiveInfo.list_waitMember.filter((member) => {
                return member.userNickname.toLowerCase().indexOf(newKeyword) > -1 || member.userProfile.toLowerCase().indexOf(newKeyword) > -1;
            });

            let result = selectedLiveInfo.list_member.filter((member) => {
                return member.userNickname.toLowerCase().indexOf(newKeyword) > -1 || member.userProfile.toLowerCase().indexOf(newKeyword) > -1;
            });

            setListSearchWaitMember(wait_result);
            setListSearchMember(result);
        } catch (err) {
            console.log("handleSearchValue() - err => ", err);
        }
    }

    return (
        <div onClick={handlePreventClick}>
            <div className="title-area">
                <div className="text-area" style={{ maxWidth: '70%' }}>
                    <span>[</span>
                    <div className="title wmax-70">
                        <span className="hiclass-text font-weight-bold" title={selectedLiveInfo.liveName}>{selectedLiveInfo.liveName}</span>
                    </div>
                    <span>] {t("멤버", { ns: "common" })}</span>
                </div>
                <span className="func-btn" style={{ position: 'absolute', right: '0' }} onClick={() => handleSelectedConfigFunc({ selectedFunc: "EDIT_MEMBER_TOGGLE" })}>
                    <BsX />
                </span>
            </div>
            <div className="input-area py-1">
                <input type="text" className="search" placeholder={`${t("닉네임", { ns: "user" })}, ${t("프로필", { ns: "user" })} ${t("검색", { ns: "common" })}`} onChange={onChangeSearchValue} onKeyPress={handleKeyPress} />
                <div className="input-group-append ml-1" title={t("검색", { ns: "common" })} onClick={() => handleSearchValue(lSearchValue)}>
                    <span className="d-flex hiclasstv-btn-transparent b-none rounded p-1">
                        <FaSearch className="d-flex font-md white-text" />
                    </span>
                </div>
            </div>
            <div className="list-group" style={{ overflow: 'auto' }}>
                <div className="title-area sub white-text" title={t("승인대기", { ns: "live" })} style={{ backgroundColor: 'rgb(58, 58, 58)' }}>
                    <b>{t("승인대기", { ns: "live" })} ({selectedLiveInfo.list_waitMember.length})</b>
                </div>
                {
                    // selectedLiveInfo.list_waitMember.length > 0 ?
                    list_searchWaitMember.length > 0 ?
                        <div className="list-group" style={{ overflow: 'auto', height: '30%', minHeight: '4rem', maxHeight: 'max-content' }}>
                            {
                                // selectedLiveInfo.list_waitMember.map(
                                list_searchWaitMember.map(member => (
                                    <div className="d-flex list-group-hitem list-group-hitem-action py-2 px-1 justify-content-center align-items-center" key={member.userSeq}>
                                        <div className="d-flex area-15 fit-content">
                                            <CustomProfileImage url={member.profileImgUrl} alt={member.userNickname} />
                                        </div>
                                        <div className="text-area flex-column align-items-start">
                                            <span className="hiclass-text" title={member.userNickname}><b>{member.userNickname}</b></span>
                                            <span className="hiclass-text hiclasstv-deepDarkgrey-text small" title={member.userProfile}>{member.userProfile}</span>
                                        </div>
                                        <div className="d-flex flex-column area-25 ml-2" onClick={handlePreventClick}>
                                            <button type="button" className="btn btn-sm green white-text m-0 mt-1 py-1 px-2" title={t("승인", { ns: "live" })} onClick={() => handleSelectedConfigFunc({ selectedFunc: "MEMBER_ACCEPT", liveSeq: selectedLiveInfo.liveSeq, memberSeq: member.userSeq })}>
                                                {t("승인", { ns: "live" })}
                                            </button>
                                            <button type="button" className="btn btn-sm red white-text m-0 my-1 py-1 px-2" title={t("거절", { ns: "common" })} onClick={() => handleSelectedConfigFunc({ selectedFunc: "MEMBER_REJECT", liveSeq: selectedLiveInfo.liveSeq, memberSeq: member.userSeq })}>
                                                {t("거절", { ns: "common" })}
                                            </button>
                                        </div>
                                    </div>
                                ))
                            }
                        </div> :
                        <div className="text-center grey-text p-2">
                            <b>{t("클래스_알림_메시지_1", { ns: "live" })}</b>
                        </div>
                }
                <div className="title-area sub hiclasstv-blue white-text" title={t("멤버", { ns: "common" })}>
                    <b>{t("멤버", { ns: "common" })} ({selectedLiveInfo.list_member.length})</b>
                </div>
                {
                    // selectedLiveInfo.list_member.length > 0 ?
                    list_searchMember.length > 0 ?
                        <div className="list-group" style={{ overflow: 'auto' }}>
                            {
                                // selectedLiveInfo.list_member.map(
                                list_searchMember.map(member => (
                                    <div className="d-flex list-group-hitem list-group-hitem-action py-2 px-1 justify-content-center align-items-center" key={member.userSeq}>
                                        <div className="d-flex area-15 fit-content">
                                            <CustomProfileImage url={member.profileImgUrl} alt={member.userNickname} />
                                        </div>
                                        <div className="text-area flex-column align-items-start">
                                            <span className="hiclass-text" title={member.userNickname}><b>{member.userNickname}</b></span>
                                            <span className="hiclass-text hiclasstv-deepDarkgrey-text small" title={member.userProfile}>{member.userProfile}</span>
                                        </div>
                                        <div className="d-flex flex-column area-25 ml-2" onClick={handlePreventClick}>
                                            {
                                                (member.isGuest === undefined || member.isGuest === null) &&
                                                <button type="button" className="btn btn-sm red white-text m-0 py-1 px-2" title={t("삭제", { ns: "common" })} onClick={() => handleSelectedConfigFunc({ selectedFunc: "MEMBER_REMOVE_TOGGLE", liveSeq: selectedLiveInfo.liveSeq, memberInfo: { liveSeq: selectedLiveInfo.liveSeq, userSeq: member.userSeq, userNickname: member.userNickname, profileImgUrl: member.profileImgUrl } })}>
                                                    {t("삭제", { ns: "common" })}
                                                </button>
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div> :
                        <div className="text-center grey-text p-2">
                            <b>{t("클래스_알림_메시지_2", { ns: "live" })}</b>
                        </div>
                }
            </div>
        </div>
    );
}

export default ConfigBroadcastLiveMember;